/**
 * Filters out all null/undefined items from the given array.
 *
 * @param  {Array} as - the target array
 *
 * @return {Array} The filtered array.
 */

function isMatch(value, type) {
  try {
    const rgx = new RegExp(value, 'gi');
    return rgx.test(type);
  } catch (err) {
    return false;
  }
}

export default function uniqueArray(propertyName, inputArray) {
  const testObject = {};
  const inputArrayTemp = [...inputArray];
  inputArrayTemp.map(item => {
    const itemPropertyName = item[propertyName];
    const itemPropertyTitle = item.title;
    const itemPropertyType = item.type;
    if (itemPropertyName in testObject) {
      if (itemPropertyName) {
        if (itemPropertyTitle && itemPropertyType) {
          if (!isMatch(itemPropertyTitle, itemPropertyType)) {
            delete testObject[itemPropertyName];
            testObject[itemPropertyName] = item;
          }
        }
      }
    } else {
      testObject[itemPropertyName] = item;
    }
    return item;
  });

  const newArray = Object.keys(testObject).map(key => testObject[key]);

  return newArray;
}
